import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	grey: {
		id: 'system-announcement-banner-main.settings.form.background-picker.grey',
		defaultMessage: 'Grey',
		description: 'Tooltip text for grey color',
	},
	purple: {
		id: 'system-announcement-banner-main.settings.form.background-picker.purple',
		defaultMessage: 'Purple',
		description: 'Tooltip text for purple color',
	},
	green: {
		id: 'system-announcement-banner-main.settings.form.background-picker.green',
		defaultMessage: 'Green',
		description: 'Tooltip text for green color',
	},
	yellow: {
		id: 'system-announcement-banner-main.settings.form.background-picker.yellow',
		defaultMessage: 'Yellow',
		description: 'Tooltip text for yellow color',
	},
	red: {
		id: 'system-announcement-banner-main.settings.form.background-picker.red',
		defaultMessage: 'Red',
		description: 'Tooltip text for red color',
	},
});
